import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { I18nProvider } from './i18n/index.tsx';
import { initTelegram } from './telegram.ts';
import './styles.css';

// Before React renders: the theme variables and viewport height must be on the
// document, or the first paint flashes the fallback palette.
initTelegram();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
